var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9172 8.75H19.8328C20.0978 8.75 20.2425 9.05902 20.0729 9.26256L17.6151 12.2119C17.4902 12.3618 17.2599 12.3618 17.135 12.2119L14.6772 9.26256C14.5075 9.05902 14.6523 8.75 14.9172 8.75Z",
    fill: "#FA8152"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16722 11.25H6.08282C6.34777 11.25 6.49251 10.941 6.32289 10.7374L3.86509 7.78808C3.74016 7.63816 3.50989 7.63816 3.38495 7.78808L0.927154 10.7374C0.757538 10.941 0.902274 11.25 1.16722 11.25Z",
    fill: "#FA8152"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3.75C8.55941 3.75 6.82573 4.63371 5.67838 6.02299C5.45858 6.28913 5.06464 6.32671 4.79849 6.1069C4.53234 5.8871 4.49477 5.49316 4.71457 5.22701C6.0892 3.56253 8.1708 2.5 10.5 2.5C14.1772 2.5 17.235 5.14563 17.8764 8.63709C17.8833 8.67463 17.8899 8.71227 17.8962 8.75H16.6251C16.0464 5.89723 13.5233 3.75 10.5 3.75ZM4.37492 11.25C4.95369 14.1028 7.47674 16.25 10.5 16.25C12.4406 16.25 14.1743 15.3663 15.3217 13.977C15.5415 13.7109 15.9354 13.6733 16.2016 13.8931C16.4677 14.1129 16.5053 14.5068 16.2855 14.773C14.9108 16.4375 12.8293 17.5 10.5 17.5C6.82289 17.5 3.765 14.8544 3.12367 11.3629C3.11677 11.3254 3.11016 11.2877 3.10382 11.25H4.37492Z",
    fill: "#FA8152"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatIcon);
export default __webpack_public_path__ + "static/media/repeatIcon.b539c5b7f1c182a541d3d57ea27e98b3.svg";
export { ForwardRef as ReactComponent };